// extracted by mini-css-extract-plugin
module.exports = {"article-actions":"blog-article_article-actions__3vMrc","article-actions-link":"blog-article_article-actions-link__2BNTo"};